import React from 'react';
import {DndProvider} from 'react-dnd'
import {HTML5Backend} from 'react-dnd-html5-backend'
import BaseTabComponent from "../BaseTabComponent";
import {stringProps} from "../../mt-fields-to-save";
import {defaultValues} from '../../mt-fields-to-save';
import DraggableBodyRow from "../../../DraggableBodyRow/DraggableBodyRow";
import svgSort from '../../../../svgs/sort.svg';
import svgSortAsc from '../../../../svgs/sort-asc.svg';
import svgSortDesc from '../../../../svgs/sort-desc.svg';
import Icon from "../../../Icon";
import {addCommasToNumber} from "../../../../utils";

const proformaDefaultValues = defaultValues.filter(field => field.tab === 'proforma-rr-tab');
const tenantNameIndex = 1;
const sqFtIndex = 2;
const startDateIndex = 1;
const endDateIndex = 2;
const psfIndex = 5;
const tiSfIndex = 6;
const lcIndex = 7;

export default class CurrentRR extends BaseTabComponent {
    constructor(props) {
        super(props);

        this.defaultTableRef = React.createRef();

        this.onTableValueChange = this.onTableValueChange.bind(this);
        this.addRowAfter = this.addRowAfter.bind(this);
        this.deleteRow = this.deleteRow.bind(this);
        this.moveRow = this.moveRow.bind(this);
        this.moveCorrespondingRows = this.moveCorrespondingRows.bind(this);
        this.sortTable = this.sortTable.bind(this);
    }

    addRowAfter(rowIdentifier) {
        this.props.addRow(
            ['current-rr-tab', 'proforma-rr-tab', 'current-reimbursement-tab', 'proforma-reimbursement-tab', 'marketing-tab'],
            [['general-information', 'detailed-information'], ['general-information', 'detailed-information'], ['detailed-information'], ['detailed-information'], ['rent-roll', 'reimbursements']],
            rowIdentifier
        );
    }

    deleteRow(rowIdentifier) {
        this.props.deleteRow(rowIdentifier);
    }

    onTableValueChange(tableIdentifier, rowCode, event, columnIndex) {
        const value = event.currentTarget.value;
        if (this.props.tab === 'current-rr-tab' || this.props.tab === 'proforma-rr-tab') {
            if (tableIdentifier === 'general-information' && columnIndex === tenantNameIndex && value === 'Vacant') {
                const values = [value, 'Lease Up'];
                proformaDefaultValues.forEach(field => {
                    values.push(field.getDefaultValue({tabs: this.props.tabs, index: rowCode, withoutCondition: true}));
                });

                this.props.valuesChange({
                    tabs: ['current-rr-tab', 'proforma-rr-tab', 'proforma-rr-tab', 'proforma-rr-tab', 'proforma-rr-tab', 'proforma-rr-tab', 'proforma-rr-tab'],
                    tables: [tableIdentifier, tableIdentifier, 'detailed-information', 'detailed-information', 'detailed-information', 'detailed-information', 'detailed-information'],
                    rowIds: [rowCode, rowCode, rowCode, rowCode, rowCode, rowCode, rowCode],
                    values,
                    columnIds: [columnIndex, columnIndex, startDateIndex, endDateIndex, psfIndex, tiSfIndex, lcIndex],
                });
            } else {
                const updated = {};
                if (tableIdentifier === 'general-information' && columnIndex === sqFtIndex)
                    updated.sqFtChanged = true;

                /**  when details are entered in proforma rent roll tab prevent the data reflecting in the current rent roll tab**/
                if(tableIdentifier ==='detailed-information' && this.props.tab==='proforma-rr-tab'){
                    this.props.valuesChange({
                        tabs: ['proforma-rr-tab'],
                        tables: [tableIdentifier],
                        rowIds: [rowCode],
                        values: [value],
                        columnIds: [columnIndex, columnIndex],
                        ...updated
                    });
                    return;
                }

                this.props.valuesChange({
                    tabs: ['current-rr-tab', 'proforma-rr-tab'],
                    tables: [tableIdentifier, tableIdentifier],
                    rowIds: [rowCode, rowCode],
                    values: [value, value],
                    columnIds: [columnIndex, columnIndex],
                    ...updated
                });
                
            }
        } else {
            this.props.valueChange({
                tab: this.props.tab,
                table: tableIdentifier,
                row: rowCode,
                value,
                columnIndex,
            });
        }
    }

    moveRow(dragIndex, hoverIndex) {
        this.props.moveRow({tabId: 'current-rr-tab', tableId: 'general-information', dragIndex, hoverIndex});
    }

    moveCorrespondingRows() {
        this.props.moveCorrespondingRows({
            changedTabId: 'current-rr-tab',
            changedTableId: 'general-information',
            tabIds: ['current-rr-tab', 'proforma-rr-tab', 'current-reimbursement-tab', 'proforma-reimbursement-tab'],
            tableIds: [['detailed-information'], ['general-information', 'detailed-information'], ['detailed-information'], ['detailed-information']],
        });
    }

    sortTable(key) {
        let sortState = this.props.sortState;
        // old direction = 'default' (desc by TENANT_ROW_ID) => new direction = 'asc'
        // old direction = 'asc' => new direction = 'desc'
        // old direction = 'desc' => new direction = 'default'
        sortState = sortState === 'asc' ? 'desc' : (sortState === 'desc' ? 'default' : 'asc');
        if (sortState === 'default') {
            this.props.sortTenants('TENANT_ROW_ID', 'asc', sortState);
            return;
        }
        this.props.sortTenants(key, sortState, sortState);
    }

    static renderCellValue(tableIdentifier,cell, columnIndex, unit, value) {
        if (!value)
            return null;
        if (cell.type && cell.type === 'date')
            return value
        let unitFront, unitLast, val = value;
        const isOptionRentNumber = tableIdentifier === 'detailed-information' && [16, 17, 18].includes(columnIndex) && !!Number(value);
        const isOptionRentText = tableIdentifier === 'detailed-information' && [16, 17, 18].includes(columnIndex) && !Number(value);

        if (isOptionRentText)
            return val;

        unitFront = unit && unit === '$' || isOptionRentNumber ? '$' : '';
        unitLast = unit && unit !== '$' ? (['Acres', 'SF', 'months'].includes(unit) ? ` ${unit}` : unit) : '';

        // number with 2 decimal places ||
        // value can be text or number; if value is number parse it
        if (tableIdentifier === 'detailed-information' && [3, 5, 6, 7, 11].includes(columnIndex) || isOptionRentNumber)
            val = addCommasToNumber(Number(value).toFixed(2));
        else if (unit === '$')
            val = addCommasToNumber(val);
        else if(cell.code === 'RR_SUITE_CODE')
            val = cell.value
        else
            return addCommasToNumber(val);

        return `${unitFront}${val}${unitLast}`;
    }

    static renderStaticValueCell(tabs, cell, domKey, isHighlighted, highlightType, rowIndex, precomputedValues) {
        const displayValue = cell.getComputedValue(tabs, rowIndex, precomputedValues).displayValue;
        return (
            <td className={`${(displayValue === '-' ? 'center-dashes' : '')} value-cell ${isHighlighted ? highlightType : ''} ${(cell.styleClasses && cell.styleClasses.length ? cell.styleClasses : '')}`}
                key={domKey}>
                <span className='text value'>{displayValue}</span>
                {cell.tooltip ? <span className='cell-tooltip'>{cell.tooltip}</span> : null}
            </td>
        );
    }

    renderEditableValueCell(tableIdentifier, rowKey, cell, columnIndex, isHighlighted, highlightType, hasRowManipulation) {
        let forceStatic = false;
        // For ProForma RR Tab, the Sq Ft column is editable just if the tenant is Vacant in the Current RR Tab
        if (this.props.tab === 'proforma-rr-tab' && tableIdentifier === 'general-information' && columnIndex === sqFtIndex) {
            const tenantName = this.props.tabs['current-rr-tab'].tables['general-information'].rows[rowKey].valueCells[tenantNameIndex].value;
            forceStatic = (tenantName.trim() !== 'Vacant' && tenantName.trim() !== 'vacant');
        }

        if (cell.forceStatic || forceStatic) {
            return (
                <td className={`value-cell ${isHighlighted ? highlightType : ''} ${(cell.styleClasses && cell.styleClasses.length ? cell.styleClasses : '')}`}
                    key={`${rowKey}-${columnIndex}`}>
                    <span className='text value'>
                        {CurrentRR.renderCellValue(tableIdentifier,cell, columnIndex, cell.unit, cell.value)}
                    </span>
                </td>
            )
        }

        const displayFormattedValue = cell.type === 'number' && ['$', '%', 'SF', 'Acres', 'Years', 'bps', 'months'].includes(cell.unit)
            || tableIdentifier === 'detailed-information' && [16, 17, 18].includes(columnIndex) || tableIdentifier === 'general-information' && [2].includes(columnIndex) ;

        return (
            <td className={`value-cell ${isHighlighted ? highlightType : ''} editable-cell ${(cell.styleClasses && cell.styleClasses.length ? cell.styleClasses : '')}`}
                key={`${this.props.tab}-${rowKey}-${columnIndex}`}>
                {hasRowManipulation ?
                    <div>
                        <label>
                            <input value={cell.value}
                                   onChange={(event) => this.onTableValueChange(tableIdentifier, rowKey, event, columnIndex)}
                                   type={cell.type !== 'date' ? cell.type : null}
                                   placeholder={cell.type === 'date' ? 'MM/DD/YYYY' : cell.unit}/>
                            {cell.value && cell.editable && cell.unit ?
                                <span className='measurement-unit'>&nbsp;{cell.unit}</span> : null}
                        </label>
                        <div className="more-button">
                            <div className="dot"/>
                            <div className="dot"/>
                            <div className="dot"/>
                            <div className="row-manipulation-container">
                                <div className="action-button" onClick={() => this.deleteRow(rowKey)}>Delete row</div>
                                <div className="action-button" onClick={() => this.addRowAfter(rowKey)}>Add row</div>
                            </div>
                        </div>
                    </div>
                    : <label
                        className={displayFormattedValue ? 'formatted-number-label' : ''}>
                        <input value={cell.value || ''}
                               onChange={(event) => this.onTableValueChange(tableIdentifier, rowKey, event, columnIndex)}
                               type={cell.type !== 'date' ? cell.type : null}
                               placeholder={cell.type === 'date' ? 'MM/DD/YYYY' : cell.unit}/>
                        <div
                            className="input-display-value">
                            {CurrentRR.renderCellValue(tableIdentifier,cell, columnIndex, cell.unit, cell.value)}
                        </div>
                    </label>
                }
            </td>
        );
    }

    renderMatrixTable(tables, tableIdentifier, hasRowManipulation = false, precomputedValues, rowsTableIdentifier, hasDnd) {
        const table = tables[tableIdentifier];

        const tableRows = Object.keys(table.rows).map((key, index) => {
            const row = table.rows[key];
            let rowIsHighlighted = false;
            let rowHighlightType = 'highlighted';

            if (row.highlightable) {
                rowIsHighlighted = row.isHighlighted(this.props.tabs, key);
                if (row.highlightType) {
                    rowHighlightType += '-' + row.highlightType;
                }
            }
            let shouldDisplayManipulationButtons = hasRowManipulation;

            const cells = row.valueCells.map((cell, cellIndex) => {
                if (cell === null) return <td key={cellIndex} className='invisible'/>;
                if (cell.hidden) return;

                let isHighlighted = rowIsHighlighted;
                let highlightType = rowHighlightType;
                if (cell.highlightable) {
                    const isCellHighlighted = cell.isHighlighted(this.props.tabs, key);
                    if (isCellHighlighted) {
                        isHighlighted = isCellHighlighted;
                        if (cell.highlightType) highlightType += '-' + cell.highlightType;
                    }
                }

                if (cell.editable) {
                    const result = this.renderEditableValueCell(tableIdentifier, key, cell, cellIndex, isHighlighted, highlightType, shouldDisplayManipulationButtons);
                    shouldDisplayManipulationButtons = false;
                    return result;
                }
                const domKey = `${key}-${cellIndex}`;
                const result = CurrentRR.renderStaticValueCell(this.props.tabs, cell, domKey, isHighlighted, highlightType, key, precomputedValues);
                shouldDisplayManipulationButtons = false;
                return result;
            });

            if (hasDnd)
                return <DraggableBodyRow key={key} rowKey={key} index={index} children={cells} moveRow={this.moveRow} moveCorrespondingRows={this.moveCorrespondingRows}/>;
            return <tr key={key} className={key}>{cells}</tr>
        });

        const tableElem = <table className={`Financials_table ${tableIdentifier}-table`} key={tableIdentifier}>
                <tbody>
                {table.headerRow && table.headerRow.length ?
                    <tr>{table.headerRow.map((cell, index) => {
                        if (rowsTableIdentifier && tables[rowsTableIdentifier].rows[0] && tables[rowsTableIdentifier].rows[0].valueCells[index].hasSort) {
                            const sortState = this.props.sortState;
                            return (
                                <td className='header-cell' key={cell}>
                                    <div className='text active' onClick={() => this.sortTable(tables[rowsTableIdentifier].rows[0].valueCells[index].code)}>
                                        {cell}
                                        <span className={`icon${sortState === 'default' ? '' : ' active'}`}>
                                            <Icon svg={sortState === 'asc' ? svgSortAsc : sortState === 'desc' ? svgSortDesc : svgSort}/>
                                        </span>
                                    </div>
                                </td>
                            );
                        }
                        return (
                            <td className='header-cell' key={cell}>
                                <div className='text'>{cell}</div>
                            </td>
                        )
                    })}</tr>
                    : null
                }

            {tableRows}

            {table.footerRow && table.footerRow.valueCells && table.footerRow.valueCells.length ?
                <tr className='footer-row'>{Object.keys(table.footerRow.valueCells).map((key) => {
                    const cell = table.footerRow.valueCells[key];
                    if (cell) {
                        return (
                            <td key={key}>
                                <div className='text'>{cell.getComputedValue(tables).displayValue}</div>
                            </td>
                        );
                    }
                    return <td className='invisible' key={key}/>;
                })}</tr>
                : null
            }
            </tbody>
        </table>;

        if (hasDnd)
            return <DndProvider backend={HTML5Backend}>{tableElem}</DndProvider>;
        return tableElem;
    }

    onTableScroll(event) {
        const mainTable = event.target;
        if(mainTable.className.includes("main-table")){
            const scrollTop = mainTable.scrollTop;
            const scrollLeft = mainTable.scrollLeft;
            const topHeader = document.getElementById('table-top');
            const leftColumn = document.getElementById('table-left');

            topHeader.style.transform = `translateX(-${scrollLeft}px)`;
            leftColumn.style.transform = `translateY(-${scrollTop}px)`;
        }
    }

    render() {
        const tab = this.props.tabs[this.props.tab];
        const isProforma = this.props.tab === 'proforma-rr-tab';
        if (tab.tables['location-date-information'].rows.date.valueCells.length == 2) {
            const index = isProforma ? 1 : 0;
            tab.tables['location-date-information'].rows.date.valueCells = [tab.tables['location-date-information'].rows.date.valueCells[index]]
        }

        // Computing heavily-used values at the start of the render.
        const precomputedValues = BaseTabComponent.precomputeHeavilyUsedValues(this.props.tabs);
        return (
            <div className="CurrentRR">

                <div className="title-container">
                    {BaseTabComponent.renderTableContainer(tab.tables[''], [
                        this.renderMatrixTable(tab.tables, 'location-date-information', false, precomputedValues)])}
                </div>

                <div className="full-table">
                    <div className={`top-left ${!isProforma ? 'with-dnd' : ''}`}>
                        {this.renderMatrixTable(tab.tables, 'top-left', false, precomputedValues, 'general-information')}
                    </div>
                    <div className={`top ${isProforma ? 'proforma' : ''}`} id="table-top">
                        {this.renderMatrixTable(tab.tables, 'header', false, precomputedValues)}
                    </div>

                    <div className='left' id="table-left">
                        <div className={!isProforma ? 'with-dnd' : ''}>
                            {this.renderMatrixTable(tab.tables, 'general-information', true, precomputedValues, null, !isProforma)}
                        </div>
                        {this.renderMatrixTable(tab.tables, 'sumed-general-information', false, precomputedValues)}
                    </div>

                    <div className={`main-table ${isProforma ? 'proforma' : ''}`} onScroll={this.onTableScroll}>
                        <div className="default-tables" ref={this.defaultTableRef}>
                            {this.renderMatrixTable(tab.tables, 'detailed-information', false, precomputedValues)}

                            {this.renderMatrixTable(tab.tables, 'sumed-detailed-information', false, precomputedValues)}
                        </div>
                        {
                            !isProforma &&
                            <div className="Financials_table_container">
                                <h3 className="Financials_table_title">Lease Notes:</h3>
                                <textarea
                                    onChange={(event) => {this.onTableValueChange('lease-notes', 'lease-notes', event, 0)}}
                                    value={tab.tables['lease-notes'].rows['lease-notes'].valueCells[0].value}
                                    disabled={stringProps[11] && stringProps[11].key === 'CURRENT_RR_NOTES' && !stringProps[11].hasOwnProperty('forceStatic')}
                                />
                            </div>
                        }
                    </div>
                </div>
            </div>
        )
    }
}
